import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "align-items-center pt-3 pb-2 mb-3 col-10 offset-1 border-bottom" }
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("video", {
        width: _ctx.videoWidth,
        height: _ctx.videoHeight,
        ref: "video"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "btn btn-dark",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open()))
      }, "カメラに接続"),
      _createTextVNode(),
      _hoisted_3
    ])
  ]))
}